import React from "react";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import TypeLabel from "./TypeLabel";
import OpenRateGauge from "./OpenRateGauge";
import { formatJpDateTime } from "../../../utils/dateUtils";

const calcOpenRate = (openedCount, deliveredCount) => {
  if (deliveredCount == null || deliveredCount === 0) return null;
  return Math.round((openedCount / deliveredCount) * 1000) / 10;
};

export default function MailMagazinesTable({ rows = [] }) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="メルマガ一覧テーブル">
        <TableHead>
          <TableRow>
            <TableCell>タイトル</TableCell>
            <TableCell>種別</TableCell>
            <TableCell>配信日時</TableCell>
            <TableCell>配信人数</TableCell>
            <TableCell>開封率</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => {
            const openRate = calcOpenRate(row.opened_count, row.delivered_count);
            return (
              <TableRow
                key={row.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.title}
                </TableCell>
                <TableCell>
                  <TypeLabel type={row.category} />
                </TableCell>
                <TableCell>{formatJpDateTime(row.delivered_at) || "—"}</TableCell>
                <TableCell>{row.delivered_count}</TableCell>
                <TableCell>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    {/* delivered_count=0 の場合は開封率を算出できないため null 扱い（OpenRateGauge 側で「データなし」表示） */}
                    {openRate != null && (
                      <Typography>
                        {openRate.toFixed(1)}%
                      </Typography>
                    )}
                    <OpenRateGauge openRate={openRate} />
                  </Box>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
